import React from "react";
import { motion } from "framer-motion";
import { ArrowDownRight } from "lucide-react";

export const Hero = ({ onQuote, onMeeting }) => {
    return (
        <section
            id="home"
            data-testid="hero-section"
            className="relative min-h-screen pt-32 pb-16 overflow-hidden"
        >
            <div className="max-w-[1500px] mx-auto px-6 md:px-12 lg:px-16">
                <div className="grid grid-cols-12 gap-6 lg:gap-12 items-end">
                    {/* Text column */}
                    <div className="col-span-12 lg:col-span-7 relative z-10">
                        <motion.div
                            initial={{ opacity: 0, y: 24 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.8 }}
                            className="overline text-[#4A4643] mb-8"
                        >
                            Architect &amp; Designer · Pune : Goa
                        </motion.div>

                        <motion.h1
                            initial={{ opacity: 0, y: 32 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 1, delay: 0.1 }}
                            className="font-serif text-[#1A1A1A] text-5xl sm:text-6xl md:text-7xl lg:text-[104px] leading-[0.95] tracking-[-0.02em] font-light"
                        >
                            Architecture
                            <br />
                            crafted with
                            <br />
                            <span className="text-[#8C7C6D]">intention.</span>
                        </motion.h1>

                        <motion.p
                            initial={{ opacity: 0, y: 24 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.8, delay: 0.35 }}
                            className="mt-10 max-w-xl text-base lg:text-lg text-[#4A4643] leading-relaxed font-light"
                        >
                            Design Desire LLP is a boutique studio shaping refined
                            residential and commercial spaces — from a Pune apartment to
                            a Goa villa, every project is a quiet, deliberate
                            conversation between space, light and material.
                        </motion.p>

                        <motion.div
                            initial={{ opacity: 0, y: 16 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.8, delay: 0.55 }}
                            className="mt-12 flex flex-wrap items-center gap-4"
                        >
                            <button
                                data-testid="hero-quote-btn"
                                onClick={onQuote}
                                className="btn-primary"
                            >
                                Get a Quote
                                <ArrowDownRight size={16} strokeWidth={1.5} />
                            </button>
                            <button
                                data-testid="hero-meeting-btn"
                                onClick={onMeeting}
                                className="btn-secondary"
                            >
                                Book a Quick Meeting
                            </button>
                        </motion.div>

                        <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ duration: 1.2, delay: 0.9 }}
                            className="mt-16 hidden md:flex items-center gap-10"
                        >
                            <div>
                                <div className="font-serif text-4xl text-[#1A1A1A]">12+</div>
                                <div className="overline text-[#4A4643] mt-2">
                                    Years of practice
                                </div>
                            </div>
                            <div className="w-px h-12 bg-[#1A1A1A]/15" />
                            <div>
                                <div className="font-serif text-4xl text-[#1A1A1A]">400+</div>
                                <div className="overline text-[#4A4643] mt-2">
                                    Spaces delivered
                                </div>
                            </div>
                            <div className="w-px h-12 bg-[#1A1A1A]/15" />
                            <div>
                                <div className="font-serif text-4xl text-[#1A1A1A]">02</div>
                                <div className="overline text-[#4A4643] mt-2">
                                    Studios — Pune & Goa
                                </div>
                            </div>
                        </motion.div>
                    </div>

                    {/* Image column */}
                    <div className="col-span-12 lg:col-span-5 relative">
                        <motion.div
                            initial={{ opacity: 0, scale: 1.04 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 1.4 }}
                            className="img-zoom relative aspect-[3/4] w-full"
                        >
                            <img
                                src="https://images.unsplash.com/photo-1628744876497-eb30460be9f6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
                                alt="Warm minimalist living room"
                                className="w-full h-full object-cover"
                            />
                        </motion.div>
                        <motion.div
                            initial={{ opacity: 0, y: 30 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 1, delay: 0.6 }}
                            className="absolute -bottom-10 -left-10 hidden lg:block w-48 h-64 img-zoom border border-[#1A1A1A]/10"
                        >
                            <img
                                src="https://images.unsplash.com/photo-1643949915134-73a4c880f7c7?crop=entropy&cs=srgb&fm=jpg&q=85&w=600"
                                alt="Kitchen detail"
                                className="w-full h-full object-cover"
                            />
                        </motion.div>
                    </div>
                </div>
            </div>

            {/* scroll cue */}
            <div className="absolute bottom-8 left-1/2 -translate-x-1/2 overline text-[#4A4643] hidden md:block">
                Scroll
            </div>
        </section>
    );
};
